module.exports = __webpack_public_path__ + "images/printer-mobile.svg";